<div
  class="flex items-top flex-wrap gap-[18px] sm:gap-[30px] sm:pr-6"
  [ngClass]="{'!gap-[18px] mobile:!gap-[22px]': slideshow}"
>
  @for (i of skeletonEntries; track i; let index = $index) {
  <div class="mb-3">
    <ngx-skeleton-loader
      [animation]="
        user.theme === 'light' || lightTheme ? 'progress' : 'progress-dark'
      "
      appearance="line"
      [theme]="{
        background:
          user.theme === 'light'
            ? 'rgb(239,241,246)'
            : lightTheme
            ? 'lightblue'
            : '#323232',
        width: slideshow
          ? isXsMobile
            ? '130px'
            : '146px'
          : isXsMobile
          ? '146px'
          : '160px',
        height: slideshow ? '222px' : isXsMobile ? '236px' : '252px',
        margin: 0
      }"
    ></ngx-skeleton-loader>
    <ngx-skeleton-loader
      [animation]="
        user.theme === 'light' || lightTheme ? 'progress' : 'progress-dark'
      "
      appearance="line"
      [theme]="{
        background:
          user.theme === 'light'
            ? 'rgb(239,241,246)'
            : lightTheme
            ? 'lightblue'
            : '#323232',
        display: 'block',
        width: '0',
        height: '0',
        margin: 0
      }"
    ></ngx-skeleton-loader>
    <ngx-skeleton-loader
      [animation]="
        user.theme === 'light' || lightTheme ? 'progress' : 'progress-dark'
      "
      appearance="line"
      [theme]="{
        background:
          user.theme === 'light'
            ? 'rgb(239,241,246)'
            : lightTheme
            ? 'lightblue'
            : '#323232',
        clear: 'both',
        width: slideshow
          ? isXsMobile
            ? '130px'
            : '146px'
          : isXsMobile
          ? '146px'
          : '160px',
        margin: 0
      }"
    ></ngx-skeleton-loader>
    <ngx-skeleton-loader
      [animation]="
        user.theme === 'light' || lightTheme ? 'progress' : 'progress-dark'
      "
      appearance="line"
      [theme]="{
        background:
          user.theme === 'light'
            ? 'rgb(239,241,246)'
            : lightTheme
            ? 'lightblue'
            : '#323232',
        display: 'block',
        width: '0',
        height: '0',
        margin: 0
      }"
    ></ngx-skeleton-loader>
    <ngx-skeleton-loader
      [animation]="
        user.theme === 'light' || lightTheme ? 'progress' : 'progress-dark'
      "
      appearance="line"
      [theme]="{
        background:
          user.theme === 'light'
            ? 'rgb(239,241,246)'
            : lightTheme
            ? 'lightblue'
            : '#323232',
        width: slideshow
          ? isXsMobile
            ? '130px'
            : '146px'
          : isXsMobile
          ? '146px'
          : '160px',
        margin: 0
      }"
    ></ngx-skeleton-loader>
  </div>
  }
</div>
